import { Injectable } from '@angular/core';

import { IRole } from '@azavista/servicelib';
import { IAzavistaGroupedFieldsComponentData, IField, IRowAction } from '@azavista/components/shared';
import { SharedService } from '../../shared/shared.service';
import { IConfirmationDialogComponentData } from '../../shared/confirmation-dialog/confirmation-dialog.interfaces';
import { TranslationKey } from '../../shared/enums';
import { IconName } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class RolesService {
    constructor(private sharedSvc: SharedService) {
    }

    async showDeleteRoleConfirmation(selectedItemsCount: number): Promise<IConfirmationDialogComponentData> {
        return this.sharedSvc.showConfirmationDialog(
            this.sharedSvc.translate(TranslationKey.deleteRoleDialogTitle),
            [
                this.sharedSvc.translate(TranslationKey.deleteRoleDialogAreYouSure),
                this.sharedSvc.translate(TranslationKey.wontBeAbleToRestoreData)
            ],
            false,
            { selectedCount: selectedItemsCount, allSelected: false, totalCount: selectedItemsCount }
        );
    }

    createNewRoleGroupData(): IAzavistaGroupedFieldsComponentData {
        const result: IAzavistaGroupedFieldsComponentData = {
            expandPanels: true,
            editModeForAllFields: true,
            singleColumn: true,
            showActionButtons: true,
            fieldsWithEntity: {
                entity: {
                    name: null
                } as IRole,
                fields: this.getEditableRoleFields()
            }
        };
        return result;
    }

    getRoles(ids: number[], roles: IRole[]): IRole[] {
        const result = roles.filter(x => ids.indexOf(x.id as number) >= 0);
        return result;
    }

    getEditableRoleFields(): IField[] {
        return this.getRoleColumns();
    }

    getRoleActions(): IRowAction[] {
        const result: IRowAction[] = [
            {
                label: this.sharedSvc.translate(TranslationKey.viewDetailsMenuAction),
                id: 'see_details', icon: IconName.visibility, singleSelectionOnly: true
            } as IRowAction,
            {
                label: this.sharedSvc.translate(TranslationKey.assignToTeamMenuAction),
                id: 'assign_to_team', icon: IconName.people, singleSelectionOnly: false
            } as IRowAction,
            {
                label: this.sharedSvc.translate(TranslationKey.deleteMenuAction),
                id: 'delete', icon: IconName.delete, singleSelectionOnly: false
            } as IRowAction
        ];
        return result;
    }

    getRoleDisplayedColumns(): string[] {
        const result: string[] = ['name'];
        return result;
    }

    getRoleColumns(): IField[] {
        const result: IField[] = [];
        const category = this.sharedSvc.translate(TranslationKey.roleFields);
        result.push({
            id: 'name', name: 'name', label: this.sharedSvc.translate(TranslationKey.name), category: category,
            schema: { type: 'string' }, editable: true, builtin: true, visible_for_planners: true
        });
        return result;
    }
}
